
import { Component, Vue, Prop } from 'vue-property-decorator';
import { OrdineMTMTestata} from '@/models';

@Component
export default class CardOrdineMTM extends Vue {
    @Prop() private ordine!: OrdineMTMTestata;
    @Prop({ default: false }) private compact!: boolean;

    private iconClassByStatus(ord: OrdineMTMTestata): string {
        if (ord.stato == "ORDINE INSERITO") {
            return 'green';
        } else if (ord.stato == "IN LAVORAZIONE") {
            return 'amber';
        } else{
            return 'blue';
        }        
    }    

    private showDetail() {        
        this.$router.push({ name: 'ordine-mtm', params: { id: this.ordine.id }});
    }
}
